import { configureStore } from "@reduxjs/toolkit";

import appReducers from "./appSlice";
import userAuthReducer from "./authUserSlice";
import createAccountReducer from "./createAccountSlice";
import createBrowsePageSlice from "./createBrowsePageSlice";
import createGigPageSlice from "./createGigPageSlice";
import createGigProposalReducer from "./createGigProposalSlice";
import createGigReducer from "./createGigSlice";
import createGoogleMapSlice from "./createGoogleMapSlice";
import createProfilePageSlice from "./createProfilePageSlice";
import createSideBarSlice from "./createSidebarSlice";
import createTabReducer from "./createTabSlice";
import financialReducer from "./financeSlice";
import gigsAndProposalsSlice from "./gigsAndProposalsSlice";
import messagingSlice from "./messagingSlice";
import notificationSlice from "./notificationSlice";
import userReducer from "./userSlice";

export const store = configureStore({
  reducer: {
    createAccount: createAccountReducer,
    user: userReducer,
    authUser: userAuthReducer,
    createGig: createGigReducer,
    activeTab: createTabReducer,
    app: appReducers,
    createGigProposal: createGigProposalReducer,
    messaging: messagingSlice,
    sidebarState: createSideBarSlice,
    gigsAndProposals: gigsAndProposalsSlice,
    browsePage: createBrowsePageSlice,
    profilePage: createProfilePageSlice,
    GigPage: createGigPageSlice,
    GoogleMapState: createGoogleMapSlice,
    financialSlice: financialReducer,
    notifications: notificationSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
